// extracted by mini-css-extract-plugin
module.exports = {"aboutWrapper":"About_aboutWrapper__35CBs","aboutInnerWrapper":"About_aboutInnerWrapper__1-P7c"};